import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import CardsPage from './pages/CardsPage';
import TransactionsPage from './pages/TransactionsPage';
import UserDashboardPage from './pages/UserDashboardPage';
import ProtectedRoute from './components/ProtectedRoute';
import { Box } from '@mui/material';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import LandingPage from './pages/LandingPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import FaqPage from './pages/FaqPage';
import FrequentlyAskedQuestionsPage from './pages/FrequentlyAskedQuestionsPage';
import LoansPage from './pages/LoansPage';
import PrivacyPoliciesPage from './pages/PrivacyPoliciesPage';
import SavingsInvestmentsPage from './pages/SavingsInvestmentsPage';
import SecurityPage from './pages/SecurityPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import AdminSettingsPage from './pages/AdminSettingsPage';
import AdminAccountStatusPage from './pages/AdminAccountStatusPage';
import KycPage from './pages/KycPage';
import AdminKycPage from './pages/AdminKycPage';

function App() {
  return (
    <Router>
      <Box sx={{ minHeight: '100vh', bgcolor: '#f5f6fa' }}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/frequently-asked-questions" element={<FrequentlyAskedQuestionsPage />} />
          <Route path="/loans" element={<LoansPage />} />
          <Route path="/privacy-policies" element={<PrivacyPoliciesPage />} />
          <Route path="/savings-investments" element={<SavingsInvestmentsPage />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/terms-and-conditions" element={<TermsConditionsPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/cards" element={<CardsPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/transactions" element={<TransactionsPage />} />
          <Route path="/user-dashboard" element={
            <ProtectedRoute>
              <UserDashboardPage />
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute adminOnly>
              <AdminDashboardPage />
            </ProtectedRoute>
          } />
          <Route path="/settings" element={
            <ProtectedRoute adminOnly>
              <AdminSettingsPage />
            </ProtectedRoute>
          } />
          <Route path="/admin/account-status" element={
            <ProtectedRoute adminOnly>
              <AdminAccountStatusPage />
            </ProtectedRoute>
          } />
          <Route path="/kyc" element={
            <ProtectedRoute>
              <KycPage />
            </ProtectedRoute>
          } />
          <Route path="/admin/kyc" element={
            <ProtectedRoute adminOnly>
              <AdminKycPage />
            </ProtectedRoute>
          } />
        </Routes>
      </Box>
    </Router>
  );
}

export default App;
